export default __webpack_public_path__ + "static/media/logo-google.dc35acb2.svg";